import { render, staticRenderFns } from "./ComentariosPagamentoLote.vue?vue&type=template&id=8fd1f6cc&scoped=true"
import script from "./ComentariosPagamentoLote.vue?vue&type=script&lang=js"
export * from "./ComentariosPagamentoLote.vue?vue&type=script&lang=js"
import style0 from "./ComentariosPagamentoLote.vue?vue&type=style&index=0&id=8fd1f6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd1f6cc",
  null
  
)

export default component.exports